import { Stack, Typography } from '@mui/material';
import { isFunction } from 'lodash';

// Components
import Table from 'src/components/Table';
import { EmptyText } from 'src/utils/constants/config';

// Utilities
import { convertToStartCase } from 'src/utils/helpers/stringHelpers';

const ContactByRole = ({
  title,
  handleOpen,
  listContact,
}: {
  title: string;
  listContact: Array<IContactCompanyManager>;
  handleOpen?: (id: string) => void;
}) => {
  const configColumn: ConfigCell<IContactCompanyManager>[] = [
    {
      id: 'full_name',
      disablePadding: true,
      label: 'Full Name',
      cell: (row: IContactCompanyManager) => {
        return (
          <Typography
            variant="body2"
            color={isFunction(handleOpen) ? 'secondary' : 'text.primary'}
            onClick={() => handleOpen?.(row.id || '')}
            fontWeight="bold"
          >
            {convertToStartCase(row.name || EmptyText)}
          </Typography>
        );
      },
    },
    {
      id: 'title',
      disablePadding: false,
      label: 'Job Title',
      cell: (row: IContactCompanyManager) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {convertToStartCase(row?.position || EmptyText)}
          </Typography>
        );
      },
    },
    {
      id: 'company_email',
      disablePadding: false,
      label: 'Email',
      cell: (row: IContactCompanyManager) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {row.company_email || EmptyText}
          </Typography>
        );
      },
    },
  ];
  return (
    <Stack spacing={2}>
      <Typography variant="h5" align="left">
        {title}
      </Typography>
      <Table
        data={listContact}
        configColumn={configColumn}
        dataKey="id"
        id={'table-company' + title}
        isPagination={false}
        maxRow={10}
      />
    </Stack>
  );
};

export default ContactByRole;
